import React, { useMemo } from 'react'

import FormResponsesSection from './FormResponsesSection'
import { studentFields } from './stuFields'
import { useProfileForm, useUser } from '../../../context'
import { Spacer } from '../../global'
import SectionFields from '../DynamicFields/SectionFields'

const StudentSection = () => {
  const { onEditionMode, userRole } = useUser()
  const { values, formActions, isNewUser } = useProfileForm()

  const isDisabled = isNewUser ? isNewUser : onEditionMode

  const fields = useMemo(
    () => studentFields({ state: values, userRole }),
    [values, userRole],
  )
  return (
    <>
      <SectionFields
        fields={fields}
        formActions={formActions}
        isDisabled={isDisabled}
      />
      {!isNewUser && (
        <>
          <FormResponsesSection
            hasForm={values.form ? true : false}
            form={typeof values.form !== 'boolean' ? values.form : undefined}
          />
          <Spacer height={20} />
        </>
      )}
    </>
  )
}

export default StudentSection
